import { Link, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router';

import alert from '~/assets/images/alert.svg';
import success from '~/assets/images/success.svg';
import { LinkStatus } from '~/types/models';

import styles from './styles.module.scss';

export const GeneratedLinkPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status') as LinkStatus | null;

  const title = useMemo(() => {
    if (!status) {
      return 'Invalid Link';
    }

    if (status === 'deactivated') {
      return 'Deactivated Link';
    }

    if (status === 'expired') {
      return 'Expired Link';
    }

    if (status === 'submitted') {
      return 'Submitted Successfully';
    }

    return null;
  }, [status]);

  return (
    <div className={styles.container}>
      <div className={styles.container__content}>
        <Typography color="var(--text-1-color)" mb="32px" variant="h4">
          {title}
        </Typography>
        <img
          alt={status === 'submitted' ? 'Success' : 'Alert'}
          src={status === 'submitted' ? success : alert}
        />
        <Typography
          color="var(--text-3-color)"
          lineHeight="24px"
          mt="32px"
          textAlign="center"
          variant="subtitle1"
        >
          {status === 'submitted' ? (
            <>
              Profile submitted successfully.
              <br /> This link is now deactivated.
            </>
          ) : (
            <>
              {!status ? 'This link is invalid' : 'This link is no longer active'}. Please contact
              <br />
              NEOM Investment Support at{' '}
              <Link color="rgb(var(--main-2-color-rgb))" href="mailto:investment@neom.com">
                investment@neom.com
              </Link>{' '}
              for further assistance.
            </>
          )}
        </Typography>
      </div>
    </div>
  );
};
